module.exports = __webpack_public_path__ + "img/icon_lightning.e50ab6de.svg";